import { motion } from 'framer-motion';
import { PLAY_PROFILE } from '../../data/technicals';

const Rating = ({ label, score, note, accent, i }) => (
  <div data-testid={`play-rating-${label.toLowerCase().replace(/\s+/g, '-')}`}>
    <div className="flex items-center justify-between gap-3">
      <span className="text-sm font-semibold text-[#111214]">{label}</span>
      <div className="flex gap-1" aria-label={`${score} out of 5`}>
        {[1, 2, 3, 4, 5].map((n) => (
          <motion.span key={n} className="w-6 sm:w-7 h-2 rounded-full"
            initial={{ backgroundColor: '#E4E4E7' }}
            whileInView={{ backgroundColor: n <= score ? accent : '#E4E4E7' }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, delay: i * 0.12 + n * 0.06 }} />
        ))}
      </div>
    </div>
    <p className="mt-1 text-xs text-[#71717A]">{note}</p>
  </div>
);

export const PlayProfile = ({ slug, accent }) => {
  const p = PLAY_PROFILE[slug];
  if (!p) return null;
  return (
    <div className="space-y-4" data-testid="play-profile">
      {p.ratings.map((r, i) => <Rating key={r.label} {...r} accent={accent} i={i} />)}
      <p className="pt-3 border-t border-[#F4F4F5] text-sm text-[#52525B]" data-testid="play-best-for">
        <span className="font-semibold text-[#111214]">Best for: </span>{p.bestFor}
      </p>
    </div>
  );
};
